import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector, useDispatch } from "react-redux";
import { sidebarReducer } from "../../Redux/store";
import "./ContentList.scss";
import "../DashBoard/sliding.css";
import uparrow from '../../images/new_ui/uparrow_con.svg'
import downarrow from '../../images/new_ui/downarrow_con.svg'  // Make sure you have this image
import axios from "axios";
import SearchBarComponent from "../../components/searchBar/searchBarComponent";
import { ReactComponent as TableRight } from "../../images/new_ui/tableright.svg";

function PastSession() {
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc');
  const dispatch = useDispatch();
  const apiLoad = useSelector((state) => state.sidebar.apiLoad);
  const [userData, setUserData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    getUsersList();
  }, []);

  async function getUsersList() {
    dispatch(sidebarReducer.apiLoad(true));
    try {
      const response = await axios.get(
        "/unitysession/getAllparticipant/" +
          JSON.parse(sessionStorage.getItem("userdata")).te_userid,
        {
          headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
          }
        }
      );
      if (response.status === 200) {
        dispatch(sidebarReducer.apiLoad(false));
        // console.log("get all content", response);
        setUserData(response.data.data);
        setSortedUserData(response.data.data);
      } else {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      }
    } catch (err) {
      dispatch(sidebarReducer.stringUpdate("AppDown"));
    }
  }

  function convertToIndianTime(dateTimeString) {
    if (!dateTimeString) return "N/A";
    const date = new Date(dateTimeString);
    const formattedDate = date.toLocaleString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
    const formattedTime = date.toLocaleString("en-IN", {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: false,
    });
    return `${formattedDate} - ${formattedTime}`;
  }

  const handleSort = (column) => {
    const newDirection = sortedColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
    
    const sortedData = [...sortedUserData].sort((a, b) => {
      const valA = (a[column] || '').toLowerCase();
      const valB = (b[column] || '').toLowerCase();
      return newDirection === 'asc' ? valA.localeCompare(valB) : valB.localeCompare(valA);
    });
    
    setSortedColumn(column);
    setSortDirection(newDirection);
    setSortedUserData(sortedData);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  
  const handleSearchSubmit = (event) => {
    event.preventDefault();
    getUsersSearchList(searchTerm);
  };

  async function getUsersSearchList(search = "") {
    dispatch(sidebarReducer.apiLoad(true));
    try {
      const url = `/unitysession/getAllparticipant/${JSON.parse(sessionStorage.getItem("userdata")).te_userid}`;
      const params = search ? { s: search } : {};
  
      const response = await axios.get(url, {
        params: params,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      });
  
      if (response.status === 200) {
        dispatch(sidebarReducer.apiLoad(false));
        // console.log("get all content", response);
        setUserData(response.data.data);
        setSortedUserData(response.data.data);
      } else {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      }
    } catch (err) {
      dispatch(sidebarReducer.stringUpdate("AppDown"));
      console.error("Search error:", err);
      toast.error("An error occurred while searching. Please try again.");
    }
  }

  const highlightText = (text, highlight) => {
    if (!highlight.trim()) return text;
    const escapedHighlight = highlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escapedHighlight})`, 'gi');
    return text.replace(regex, '<span class="highlighted-text">$1</span>');
  };

  const getSortIcon = (column) => {
    if (sortedColumn !== column) return uparrow;
    return sortDirection === 'asc' ? uparrow : downarrow;
  };
  const [sortedUserData, setSortedUserData] = useState([]);

  useEffect(() => {
    setSortedUserData(userData);
  }, [userData]);
  return (
    <div className="content-list">
      <ToastContainer />
      <div className="container-fluid">
        <div className="search-section">     
          <SearchBarComponent 
            className="search-bar-div"
            value={searchTerm}
            onChange={handleSearchChange}
            onSubmit={handleSearchSubmit}
          />
        </div>
        <div className="container">
          <div className="content-list-container">
            <h5>Past Session</h5>
            {apiLoad ? (
              <div style={{ height: "80vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <div className="spinnerApi"></div>
              </div>
            ) : (
              <div style={{height: "93%"}}>
                <div className="container-fluid g-0 table-custom" style={{height: "100%"}}>
                  <div className="table-wrapper-scroll-y user-list-table">
                    <table stickyHeader aria-label="sticky table">
                      <thead>
                        <tr>
                          <th>
                            Session Name
                            <img 
                              className="filter-icon" 
                              src={getSortIcon('te_unitytitle')} 
                              alt="filter" 
                              onClick={() => handleSort('te_unitytitle')} 
                            />
                          </th>
                          <th> 
                            Start Date-Time
                            <img 
                              className="uparrow-icon" 
                              src={getSortIcon('te_iscreatedAt')} 
                              alt="sort" 
                              onClick={() => handleSort('te_iscreatedAt')} 
                            /> 
                          </th>
                          <th>
                            Close Date-Time 
                            <img 
                              className="uparrow-icon" 
                              src={getSortIcon('te_sessionisclosedat')} 
                              alt="sort" 
                              onClick={() => handleSort('te_sessionisclosedat')} 
                            /> 
                          </th>
                        </tr>
                      </thead>
                      <tbody>
  {sortedUserData.map((item, index) => (
    <tr key={`${item.te_unitytitle}-${item.te_iscreatedAt}-${index}`}>
      <td>
        <div className="unity-title" title={item.te_unitytitle} dangerouslySetInnerHTML={{
          __html: highlightText(item.te_unitytitle, searchTerm)
        }} />
      </td>
      <td dangerouslySetInnerHTML={{
        __html: highlightText(convertToIndianTime(item.te_iscreatedAt), searchTerm)
      }} />
      <td dangerouslySetInnerHTML={{
        __html: highlightText(convertToIndianTime(item.te_sessionisclosedat), searchTerm)
      }} />
    </tr>
  ))}
</tbody>
                    </table>
                  </div>
                  <div style={{alignContent: "center"}}>
                    <TableRight style={{ width: "300px", height: "auto",  cursor: "pointer" }} />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PastSession;